import React, { Component } from "react";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";
import ConciergeTeeTimeBookingOutcomes from "../../../assets/components/reports/ConciergeTeeTimeBookingOutcomes";

class ConciergeTeeTimeBookingOutcomesReport extends Component {
    constructor(props) {
        super(props);
        if (this.props.user.canViewConciergeReports !== true) {
            this.props.history.replace("/reports");
        }
    }

    render() {
        if (this.props.user.canViewConciergeReports !== true) {
            return null;
        }

        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    <div className='container'>
                        <div className='row'>
                            <div className='col'>
                                <h2>Tee-Time Booking Outcomes</h2>
                            </div>
                        </div>

                        <div className='row mt-3'>
                            <div className='col'>
                                <ConciergeTeeTimeBookingOutcomes />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    }
}

export default ConciergeTeeTimeBookingOutcomesReport;
